const processSchedule = (schedule) => {
  if (schedule) {
    let entriesSchedule = Object.entries(schedule);

    const date = new Date();
    const day = date.getDay();
    const currentHour = `${date.getHours()}.${date.getMinutes()}`;

    const todaySchedule = entriesSchedule[day - 1];
    let parseTodaySchedule = todaySchedule[1].split("/");

    if (parseTodaySchedule.length === 1) {
      if (parseTodaySchedule[0].split("-").length > 1) {
        let tempParseTodaySchedule = [];
        parseTodaySchedule = parseTodaySchedule[0].split("-");
        for (const element of parseTodaySchedule) {
          tempParseTodaySchedule.push(element.replace(":", "."));
        }
        if (
          currentHour > parseFloat(tempParseTodaySchedule[0]) &&
          currentHour < parseFloat(tempParseTodaySchedule[1])
        ) {
          return `ouvert - ${todaySchedule[1]}`;
        } else {
          return "Fermé";
        }
      } else return "Fermé";
    } else {
      let tempParseTodaySchedule = [];
      for (const open of parseTodaySchedule) {
        tempParseTodaySchedule.push(open.split("-"));
      }
      tempParseTodaySchedule = tempParseTodaySchedule.flat();

      for (let i = 0; i < tempParseTodaySchedule.length; i++) {
        tempParseTodaySchedule[i] = tempParseTodaySchedule[i].replace(":", ".");
      }
      for (let i = 0; i < tempParseTodaySchedule.length; i += 2) {
        if (
          currentHour > parseFloat(tempParseTodaySchedule[i]) &&
          currentHour < parseFloat(tempParseTodaySchedule[i + 1])
        ) {
          return `ouvert - ${todaySchedule[1]}`;
        }
      }
      return "Fermé";
    }
  }
};

export default processSchedule;
